import React from "react";

const ConfettiCapIcon = ({ width }) => {
  return (
    <svg
      width={width}
      viewBox='-5.41 0 503.28 503.28'
      xmlns='http://www.w3.org/2000/svg'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <g
          id='Group_13'
          data-name='Group 13'
          transform='translate(-306.168 1611.899)'
        >
          {" "}
          <path
            id='path268'
            d='M375.011-1110.264l131.96-71.32,140.46-75.893a13.175,13.175,0,0,0,7.021-10.76,13.219,13.219,0,0,0-5.119-11.813l-98.809-77.56-98.809-77.56a12.982,12.982,0,0,0-12.608-2.107,13.117,13.117,0,0,0-8.631,9.507l-38.569,155.88-36.233,146.44a13.331,13.331,0,0,0,4.772,13.933,13.081,13.081,0,0,0,14.565,1.253'
            fill='#f9b317'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path270'
            d='M448.008-1374.677c21.376,2.587,40.644,22.933,62.02,25.507,13.456,1.627,27.748-3.8,41.823-7.4l-1.327-1.04-98.809-77.56a12.982,12.982,0,0,0-12.608-2.107,13.117,13.117,0,0,0-8.631,9.507l-14.292,57.76c10.783-3.027,21.547-5.906,31.824-4.667'
            fill='#43bb4e'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path272'
            d='M493.088-1285.9c-21.376-2.573-40.644-22.933-62.021-25.507-9.836-1.187-20.119,1.387-30.439,4.267l-8.721,35.253-8.1,32.72c11.764-3.293,23.557-6.84,34.769-5.48,21.375,2.573,40.644,22.92,62.019,25.507s44.86-12.627,66.236-10.053c9.6,1.16,18.771,5.893,27.9,11l72.7-39.28a13.175,13.175,0,0,0,7.021-10.76,13.519,13.519,0,0,0-1.172-6.907c-10.821,3.04-21.625,5.933-31.937,4.693-21.375-2.573-40.644-22.933-62.018-25.507s-44.86,12.627-66.236,10.053'
            fill='#43bb4e'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path274'
            d='M444.919-1161.957q-26.058,21.36-56.248,44.307l71.56-38.667,46.739-25.253,67.764-36.627,72.7-39.28a13.177,13.177,0,0,0,7.023-10.76,13.518,13.518,0,0,0-1.173-6.906,13.572,13.572,0,0,0-3.945-4.907l-53.476-41.973a241.069,241.069,0,0,1-19.932,31.187q-22.294,30.06-59.531,65.906-30.666,29.54-71.476,62.973'
            fill='#db8e19'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path276'
            d='M460.232-1156.317c-19.94-4.24-38.22-22.467-58.373-24.906-10.863-1.307-22.268,1.973-33.668,5.187l-12.517,50.587a13.331,13.331,0,0,0,4.772,13.933,13.081,13.081,0,0,0,14.565,1.253l85.221-46.053'
            fill='#43bb4e'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path278'
            d='M516.393-1224.93c10.32-2.88,20.6-5.453,30.44-4.267,9.6,1.16,18.771,5.893,27.9,11h0l72.7-39.28c.257-.146.509-.293.753-.44h0l.181-.107h0c.181-.12.357-.24.531-.36h0c.173-.133.343-.253.509-.387h0l.327-.253h0l.157-.147h0l.159-.133h0l.153-.133h0l.152-.147h0l.148-.147h0l.145-.133h0l.145-.147.143-.16.139-.147h0l.136-.16h0l.133-.147.131-.16h0l.129-.16.125-.16h0c.125-.16.247-.32.363-.493l.116-.173h0l.112-.16v-.013l.111-.16h0l.108-.173.1-.187h0l.1-.173.2-.36h0l.093-.187.091-.173h0l.088-.187.085-.187.081-.2h0l.08-.187.077-.187.072-.2.072-.2.068-.187.065-.2.061-.2.059-.2h0l.056-.213.053-.2.051-.2.047-.213.045-.213.04-.2h0l.039-.213.035-.213.032-.213.029-.213.027-.227.024-.213.019-.213.011-.12.008-.12h0l.007-.107.008-.12h0l0-.12.005-.107.005-.12h0l0-.107v-.12h0v-.453h0v-.12h0l0-.107,0-.12-.005-.107h0l-.005-.107-.007-.12h0l-.005-.107h0l-.008-.107v-.013l-.009-.107h0l-.009-.107h0l-.011-.107h0l-.012-.12h0l-.013-.107h0l-.012-.107h0l-.013-.107h0l-.015-.12h0l-.017-.107h0l-.016-.107h0l-.019-.107h0l-.019-.107h0l-.02-.107h0l-.021-.107h0l-.021-.107h0l-.02-.107h0l-.023-.107h0l-.023-.107h0l-.024-.107h0l-.027-.107h0l-.025-.107h0l-.025-.107h0l-.028-.107h0l-.028-.107h0l-.028-.093v-.013l-.031-.093h0l-.031-.107h0l-.031-.107h0l-.033-.093v-.013l-.033-.093h0l-.035-.107h0l-.035-.093v-.013l-.036-.093h0l-.037-.107h0l-.039-.093h0l-.039-.107h0l-.04-.093h0l-.039-.107h0l-.041-.093h0l-.04-.107h0l-.044-.093h0l-.041-.093v-.013l-.044-.093h0c-10.821,3.04-21.624,5.933-31.936,4.693-15.72-1.893-30.3-13.4-45.416-20.387h0q-22.295,30.059-59.531,65.906h0'
            fill='#32a940'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path280'
            d='M460.232-1156.317a66.181,66.181,0,0,1-15.312-5.64h0q-26.05,21.34-56.227,44.293l71.54-38.653'
            fill='#32a940'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path282'
            d='M582.376-1385.7a7.561,7.561,0,0,1-10.663,1.347,7.7,7.7,0,0,1-1.337-10.747c3.913-5.08,9.107-8.28,14.292-11.493,3.98-2.467,7.968-4.933,10.2-7.813l-.019-.013c1.011-1.307-.052-7.12-1.115-12.92-1.68-9.173-3.361-18.36,1.827-25.08,5.884-7.613,18.64-5.387,31.387-3.16,8.3,1.44,16.6,2.893,16.887,2.52s-3.137-8.12-6.559-15.853c-5.267-11.92-10.536-23.853-4.667-31.467l-.017-.013c5.176-6.707,14.447-7.32,23.711-7.933,5.832-.373,11.668-.76,12.664-2.053,2.256-2.92,3.649-7.413,5.039-11.907,1.8-5.8,3.605-11.613,7.571-16.746a7.535,7.535,0,0,1,10.633-1.32,7.679,7.679,0,0,1,1.308,10.72c-2.209,2.853-3.613,7.387-5.015,11.906-1.809,5.84-3.621,11.68-7.536,16.747-5.179,6.707-14.448,7.32-23.712,7.933-5.833.373-11.669.76-12.665,2.053l-.016-.013-.012.013c-.285.36,3.136,8.107,6.556,15.853,5.275,11.92,10.549,23.853,4.659,31.48s-18.633,5.387-31.381,3.16c-8.3-1.44-16.6-2.893-16.892-2.52-.988,1.28.077,7.107,1.141,12.92,1.683,9.2,3.368,18.4-1.795,25.08l-.019-.013-.009.013c-3.943,5.107-9.1,8.293-14.256,11.48-3.963,2.453-7.933,4.907-10.192,7.84'
            fill='#f0393c'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path284'
            d='M538.825-1424.05a7.583,7.583,0,0,1-9.98,4.013,7.686,7.686,0,0,1-3.98-10.067c2.837-6.653,7.244-12.08,11.549-17.387,3.916-4.827,7.74-9.547,9.148-14.027.781-2.493-2.924-8.253-6.54-13.867-4.977-7.733-9.851-15.307-8.351-23.293,1.692-9.013,11.961-14.147,22.013-19.187,6.379-3.187,12.625-6.32,12.644-6.733.032-.747-5.637-4.427-11.2-8.027-8.252-5.333-16.375-10.6-17.344-18.52-.863-7.067,3.009-13.293,6.84-19.453,2.416-3.88,4.8-7.72,4.485-8.733-1.059-3.36-4.167-6.973-7.249-10.56a62.867,62.867,0,0,1-7.933-10.667,7.7,7.7,0,0,1,3-10.4,7.566,7.566,0,0,1,10.308,3.027,50.78,50.78,0,0,0,6.089,8.04c4.081,4.747,8.193,9.533,10.22,15.947,2.448,7.773-1.793,14.6-6.087,21.493-2.385,3.827-4.8,7.707-4.585,9.44.1.813,5.237,4.133,10.456,7.507,9.2,5.96,18.564,12.027,18.148,21.56-.411,9.44-10.637,14.573-21.079,19.8-6.693,3.347-13.533,6.773-13.815,8.28-.379,2,2.856,7.027,6.156,12.16,5.555,8.627,11.249,17.48,8.321,26.8-2.293,7.293-7.031,13.133-11.883,19.106-3.639,4.494-7.361,9.08-9.351,13.747'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path286'
            d='M627.161-1349.8a7.545,7.545,0,0,1-10.635-1.427,7.689,7.689,0,0,1,1.427-10.72c6.733-5.2,14.364-7.307,21.8-9.36,5-1.387,9.912-2.733,13.483-4.973,2.4-1.493,4.224-8.147,6.008-14.627,2.671-9.733,5.285-19.24,13.321-23,9.083-4.253,18.931,3.027,28.56,10.16,5.636,4.173,11.163,8.267,12.029,8,1.116-.333,3.535-6.427,5.908-12.4,3.964-9.973,7.861-19.773,16.9-20.92,8.115-1.027,14.484,4.533,20.773,10.013,3.469,3.027,6.9,6.027,8.465,6.12a44.247,44.247,0,0,0,9.611-1c5.841-1.013,11.655-2.027,18.136-.32a7.641,7.641,0,0,1,5.435,9.307,7.58,7.58,0,0,1-9.236,5.48c-3.256-.853-7.508-.12-11.781.627a55.326,55.326,0,0,1-13.055,1.173c-6.7-.413-12.069-5.093-17.493-9.827-3.732-3.253-7.513-6.56-9.011-6.36-.137.013-2.384,5.653-4.664,11.4-3.723,9.373-7.519,18.92-15.652,21.373-8.076,2.44-16.619-3.88-25.336-10.333-6.055-4.48-12.247-9.067-13.232-8.6-1.655.773-3.343,6.907-5.063,13.173-2.565,9.333-5.188,18.893-12.661,23.56-5.409,3.373-11.376,5.027-17.463,6.707-5.983,1.64-12.124,3.347-16.575,6.773'
            fill='#6759b2'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path288'
            d='M482.417-1475.73a11.017,11.017,0,0,0,10.951-11.04,11.017,11.017,0,0,0-10.951-11.04,11.018,11.018,0,0,0-10.953,11.04,11.018,11.018,0,0,0,10.953,11.04'
            fill='#f0393c'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path290'
            d='M625.376-1554.223a12.237,12.237,0,0,0,12.165-12.267,12.237,12.237,0,0,0-12.165-12.267,12.238,12.238,0,0,0-12.167,12.267,12.238,12.238,0,0,0,12.167,12.267'
            fill='#6759b2'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path292'
            d='M744-1472.97a12.238,12.238,0,0,0,12.165-12.267A12.246,12.246,0,0,0,744-1497.5a12.247,12.247,0,0,0-12.167,12.266A12.238,12.238,0,0,0,744-1472.97'
            fill='#32a940'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path294'
            d='M757.689-1316.583a16.828,16.828,0,0,0,16.729-16.867,16.828,16.828,0,0,0-16.729-16.867,16.831,16.831,0,0,0-16.732,16.867,16.831,16.831,0,0,0,16.732,16.867'
            fill='#f9b317'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path296'
            d='M610.2-1118.691A47.387,47.387,0,0,1,635.94-1146.2a3.422,3.422,0,0,0,2.1-3.307,3.431,3.431,0,0,0-2.289-3.187,47.268,47.268,0,0,1-27.272-25.947,3.412,3.412,0,0,0-3.288-2.12,3.412,3.412,0,0,0-3.159,2.307,47.323,47.323,0,0,1-25.739,27.493,3.44,3.44,0,0,0-2.1,3.32,3.444,3.444,0,0,0,2.291,3.187,47.262,47.262,0,0,1,27.271,25.947,3.416,3.416,0,0,0,3.289,2.12,3.433,3.433,0,0,0,3.159-2.307'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path298'
            d='M619.448-1162.81q-1.708,24.2-26.659,28.48a47.369,47.369,0,0,1,10.965,15.827,3.416,3.416,0,0,0,3.289,2.12,3.433,3.433,0,0,0,3.159-2.307A47.386,47.386,0,0,1,635.94-1146.2a3.422,3.422,0,0,0,2.1-3.307,3.431,3.431,0,0,0-2.289-3.187,46.787,46.787,0,0,1-16.305-10.12'
            fill='#4267ba'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path300'
            d='M333.863-1348.663l19.753,19.92a4.735,4.735,0,0,1,0,6.64L333.863-1302.2a4.637,4.637,0,0,1-6.581,0L307.527-1322.1a4.735,4.735,0,0,1,0-6.64l19.755-19.92a4.637,4.637,0,0,1,6.581,0'
            fill='#f0393c'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path302'
            d='M343.74-1338.7q-3.346,20.6-26.335,26.547l9.876,9.96a4.635,4.635,0,0,0,6.58,0l19.753-19.907a4.73,4.73,0,0,0,0-6.64l-9.875-9.96'
            fill='#cb3325'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path304'
            d='M726.52-1259.57l19.756,19.92a4.718,4.718,0,0,1,0,6.627L726.52-1213.1a4.636,4.636,0,0,1-6.58,0l-19.756-19.92a4.718,4.718,0,0,1,0-6.627l19.756-19.92a4.636,4.636,0,0,1,6.58,0'
            fill='#43bb4e'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path306'
            d='M736.4-1249.61q-3.344,20.6-26.333,26.547l9.876,9.96a4.636,4.636,0,0,0,6.58,0l19.753-19.92a4.714,4.714,0,0,0,0-6.627l-9.876-9.96'
            fill='#32a940'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path308'
            d='M369.8-1504.476a4.158,4.158,0,0,1,4.239-4.08,4.17,4.17,0,0,1,4.051,4.28l-.42,18.36a4.159,4.159,0,0,1-4.24,4.08,4.171,4.171,0,0,1-4.049-4.28l.42-18.36'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path310'
            d='M369-1469.4a4.159,4.159,0,0,1,4.24-4.08,4.16,4.16,0,0,1,4.049,4.267l-.42,18.36a4.16,4.16,0,0,1-4.24,4.08,4.159,4.159,0,0,1-4.049-4.267l.42-18.36'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path312'
            d='M346.735-1474.1a4.16,4.16,0,0,1-4.049-4.267,4.16,4.16,0,0,1,4.24-4.08l18.213.413a4.171,4.171,0,0,1,4.049,4.28,4.159,4.159,0,0,1-4.24,4.08l-18.213-.427'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
          <path
            id='path314'
            d='M381.528-1473.29a4.17,4.17,0,0,1-4.051-4.28,4.161,4.161,0,0,1,4.241-4.08l18.211.427a4.166,4.166,0,0,1,4.051,4.267,4.162,4.162,0,0,1-4.241,4.093l-18.211-.427'
            fill='#5b7fc9'
            fill-rule='evenodd'
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export default ConfettiCapIcon;
